export enum CardType {
  Critico = 1,
  Atencao = 2,
  Regular = 3,
  Excelente = 4,
}
